





















import { defineComponent } from '@vue/composition-api';
import { PropType } from 'vue';
import { useI18N } from '../../../../composables/use-vue-i18n';
import { CloudUnitType } from '../../../../store/product/types';

export default defineComponent({
  name: 'OrderWidgetBoxRam',
  props: {
    duration: {
      type: Number,
      required: true,
    },
    units: {
      type: Number,
      required: true,
    },
    formattedPrice: {
      type: String,
      required: true,
    },
    cloudUnitType: {
      type: Object as PropType<CloudUnitType>,
      required: true,
    },
  },
  setup() {
    return {
      i18n: useI18N(),
    };
  },
});
